import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ru from 'vuetify/es5/locale/ru';
import de from 'vuetify/es5/locale/de';
import en from 'vuetify/es5/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: {
            ru, en, de
        },
        current: 'ru'
    },
    theme: {
        themes: {
            light: {
                primary: '#233347',
                secondary: '#170F16',
                accent: '#4C558E',
                danger: '#8D3E4B',
                success: '#3A9C85'
            },
        },
    },
});
